import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {Test} from "common/flowmaster/types/test";
import {LlmRunId} from "common/flowmaster/types/llm_run";

export type WorkflowTestDeleteAction = {
  type: WorkflowsActionTypes["LLM_RUN_TESTS_RERUN"]["SUCCESS"];
  payload: {links: Record<string, unknown>; tests: Test[]};
};

export default function rerunWorkflowTests(requestor) {
  return createReduxPromiseAction(
    ActionTypes.LLM_RUN_TESTS_RERUN,
    (organisationId: OrganisationId, llmRunId: LlmRunId) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/llm_run/${llmRunId}/test/rerun`,
          {},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
